import {
	BlockquotePlugin,
	BoldPlugin,
	CodePlugin,
	ItalicPlugin,
	StrikethroughPlugin,
	SuperscriptPlugin,
	SubscriptPlugin,
	UnderlinePlugin,
	HorizontalRulePlugin,
	HighlightPlugin,
	KbdPlugin
} from "@platejs/basic-nodes/react";
import { KEYS } from "@platejs/utils";
import {
	CodeBlockPlugin,
	CodeLinePlugin,
	CodeSyntaxPlugin,
} from "@platejs/code-block/react";
import type { NodeComponent } from "@platejs/core";
import { ParagraphPlugin, PlateElement, PlateLeaf  } from "@platejs/core/react";
import { withProps } from "@udecode/cn";

import { LinkPlugin } from "@platejs/link/react";
import {
	ListItemPlugin,
	NumberedListPlugin,
	BulletedListPlugin,
	TodoListPlugin,
} from "@platejs/list-classic/react";
import { ImagePlugin, MediaEmbedPlugin } from "@platejs/media/react";
import {
	TablePlugin,
	TableCellHeaderPlugin,
	TableCellPlugin,
	TableRowPlugin,
} from "@platejs/table/react";

import { BlockquoteElement } from "./BlockquoteElement";
import { HrElement } from "./HrElement";
import { HeadingElement } from "./HeadingElement";
import { ListElement } from "./ListElement";
import { ParagraphElement } from "./ParagraphElement";
import { TableElement } from "./TableElement";
import { ImageElement } from "./ImageElement";
import { KbdLeaf } from "./KbdLeaf";
import { HighlightLeaf } from "./HighlightLeaf";
import { CodeLeaf } from "./CodeLeaf";
import { LinkElement } from "./LinkElement";
import { TableRowElement } from "./TableRowElement";
import { TableCellElement, TableCellHeaderElement } from "./TableCellElement";
import { CodeBlockElement } from "./CodeBlockElement";
import { CodeLineElement } from "./CodeLineElement";
import { CodeSyntaxLeaf } from "./CodeSyntaxLeaf";
// import { ExcalidrawElement } from "./ExcalidrawElement";
import { MediaEmbedElement } from "./MediaEmbedElement";

export const createPlateUI = (
	overrideByKey?: Partial<Record<string, NodeComponent>>
) => {
	const components: Record<string, NodeComponent> = {
		[BlockquotePlugin.key]: BlockquoteElement,
		[CodeBlockPlugin.key]: CodeBlockElement,
		[CodeLinePlugin.key]: CodeLineElement,
		[CodeSyntaxPlugin.key]: CodeSyntaxLeaf,
		[HorizontalRulePlugin.key]: HrElement,
		[KEYS.h1]: withProps(HeadingElement, { variant: "h1" }),
		[KEYS.h2]: withProps(HeadingElement, { variant: "h2" }),
		[KEYS.h3]: withProps(HeadingElement, { variant: "h3" }),
		[ImagePlugin.key]: ImageElement,
		[ListItemPlugin.key]: withProps(PlateElement, { as: "li" }),
		[LinkPlugin.key]: LinkElement,
		[MediaEmbedPlugin.key]: MediaEmbedElement,
		[BulletedListPlugin.key]: withProps(ListElement, { variant: "ul" }),
		[NumberedListPlugin.key]: withProps(ListElement, { variant: "ol" }),
		[ParagraphPlugin.key]: ParagraphElement,
		[TablePlugin.key]: TableElement,
		[TableCellPlugin.key]: TableCellElement,
		[TableCellHeaderPlugin.key]: TableCellHeaderElement,
		// [ELEMENT_TODO_LI]: TodoListElement,
		[TableRowPlugin.key]: TableRowElement,
		// [ELEMENT_EXCALIDRAW]: ExcalidrawElement,
		[BoldPlugin.key]: withProps(PlateLeaf, { as: "strong" }),
		[CodePlugin.key]: CodeLeaf,
		[HighlightPlugin.key]: HighlightLeaf,
		[ItalicPlugin.key]: withProps(PlateLeaf, { as: "em" }),
		[KbdPlugin.key]: KbdLeaf,
		[StrikethroughPlugin.key]: withProps(PlateLeaf, { as: "s" }),
		[SubscriptPlugin.key]: withProps(PlateLeaf, { as: "sub" }),
		[SuperscriptPlugin.key]: withProps(PlateLeaf, { as: "sup" }),
		[UnderlinePlugin.key]: withProps(PlateLeaf, { as: "u" }),
	};

	if (overrideByKey)
		Object.entries(overrideByKey).forEach(([key, component]) => {
			if (!component) return;

			components[key] = component;
		});

	return components;
};
